<!--
 * @Description: 站点底部
 * @Author: F-Stone
 * @LastEditTime: 2025-08-14 02:27:38
-->
<template>
  <div :class="$style['g-foot']">
    <div :class="[$style['m-container'],$style['siteFoot-width']]">
      <div :class="$style['m-container--inner']" class="flex items-center justify-between">
        <div :class="$style['state--pos-left']">
          <div :class="$style['copyright']">
            <span class="text"> &copy; 2026 SUPERDAO INC. </span>
          </div>
        </div>
        <div :class="$style['state--pos-right']">
          <button
              :class="$style['btn--lang']"
              class="flex items-center"
              @click="emitShowLocalSwitchPanel"
          >
            <span class="text">{{ langName }}</span>
            <i :class="$style['ic']" class="ueicon-globe"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SiteFoot',
  computed: {
    langName() {
      const code = this.$i18n && this.$i18n.locale ? this.$i18n.locale : 'en';
      const map = {
        en: 'English',
        'zh-CN': '简体中文',
        ko: '한국어',
        'zh-TC': '繁體中文',
        'zh-Hk': '繁體中文',
        ja: '日本語',
        ru: 'Русский',
        fa: 'فارسی',
        uk: 'Українська',
        es: 'Español',
        vi: 'Tiếng Việt',
        fr: 'Français',
        pt: 'Português',
      };
      return map[code] || code;
    },
  },
  methods: {
    emitShowLocalSwitchPanel() {
      this.$emit('showLocalSwitchPanel');
    },
  },
};
</script>
<style lang="scss" module>
@import "../../assets/css/scss-utils/scss/abstracts/mixins";
@import "../../assets/css/scss-utils/scss/abstracts/_breakpoint";
@import "../../assets/css/variable";
@import "../../assets/css/mixin";
@import "../../assets/css/var";

.g-foot {
  .siteFoot-width{
    width: 100%;
    padding: 0 280px;
  }
  .m-container--inner {
    padding: 22px 0;

    transition: var(--transition-theme-color);

    border-top: 1px solid color(var(--font-color), 0.1);
  }

  .copyright {
    font-size: 13px;
    font-weight: 500;
    line-height: 140%;

    transition: var(--transition-theme-color);

    color: color(var(--font-color), 0.6);
  }

  .btn--lang {
    font-size: 14px;
    font-weight: 400;
    line-height: 160%; /* 22.4px */

    padding: em(6px, 14px) em(15px, 14px);

    cursor: pointer;
    transition: var(--transition-theme-color);

    color: color(var(--font-color), 0.6);
    border: 2px solid color(var(--font-color), 0.3);
    border-radius: 20px;

    .ic {
      font-size: em(16px, 14px);

      margin-left: em(4px, 14px);
    }

    &:hover {
      color: color(var(--font-color));
      border-color: color(var(--font-color));
    }
  }
}
@include media-breakpoint-down(xxxl) {
  .g-foot{
    .siteFoot-width{
      width: 100%;
      padding: 0 140px;
    }
  }
}
@include media-breakpoint-down(xxl) {
  .g-foot{
    .siteFoot-width{
      width: 100%;
      padding: 0 140px;
    }
  }
}
@include media-breakpoint-down(lg) {
  .g-foot {
    .m-container--inner {
      padding: 14px 0;
    }

    .btn--lang {
      font-size: 12px;
    }
  }
}
</style>
